<template>
    <div class="container">
        <div class="about-banner">
            <img src="../../assets/images/sh1.png" />
            <p class="title">{{ t('aftersales.moduleA.title') }}</p>
            <p class="subtitle">{{ t('aftersales.moduleA.desc') }}</p>
        </div>
        <div class="navigation-bar">
            <div class="navigation-bar-txt">
                <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
                <span>{{ t('Companyinfo') }}</span>
            </div>
        </div>
        <div class="traninglist">
            <h2 class="title">{{ t('afterserver') }}</h2>
            <ul>
                <li v-for="item in farmList.slice(0, 3)" :key="item">
                    <img :src="item.qrcode" />
                    <span class="span-txt">{{ item.name }}</span>
                    <div class="description">{{ item.description}}</div>
                </li>
            </ul>
            <ul>
                <li v-for="item in farmList.slice(3, 6)" :key="item">
                    <img :src="item.qrcode" />
                    <span class="span-txt">{{ item.name }}</span>
                    <div class="description">{{ item.description}}</div>
                </li>
            </ul>
            <ul>
                <li v-for="item in farmList.slice(6, 9)" :key="item">
                    <img :src="item.qrcode" />
                    <span class="span-txt">{{ item.name }}</span>
                    <div class="description">{{ item.description}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>
import {watch,computed} from "vue";
import { useI18n } from 'vue-i18n'
const { t,locale} = useI18n()
// const farmListCn = ref([
//     {
//         name: 'PT-VI Tester',
//         qrcode: require("../../assets/images/sh2.png"),
//         description:'Vacuum system ISO6690 test Pulse curve test Milking cluster standard test NMC Humidity test'
//     },
//     {
//         name: 'Vadia vacuum diagnostic system',
//         qrcode: require("../../assets/images/sh3.png"),
//         description:'MTT (Milking Time Test): Dynamic milking process analysis PT (Pulsation Test): ISO 6690 compliant pulsation evaluation FT (Function Test): Accurate assessment of milking cluster attachment and detachment'

//     },
//     {
//         name: 'Rapid response services',
//         qrcode: require("../../assets/images/sh4.png"),
//         description:'Our experts provide immediate remote support to resolve issues in real time. When on-site intervention is required, we guarantee engineer arrival within 6 hours, minimizing disruption and protecting your operation.'


//     },
//     {
//         name: 'Dedicated on-site support',
//         qrcode: require("../../assets/images/sh5.png"),
//         description:'Our engineers are stationed on-site to provide 24/7 dedicated support, delivering customized maintenance strategies that ensure continuous performance, reduced downtime, and long-term equipment reliability.'

//     }, 
//     {
//         name: 'Data-driven farm optimization',
//         qrcode: require("../../assets/images/sh6.png"),
//         description:'Powered by Afikim systems, our advanced analytics platform delivers full-farm visibility across all operational modules. We transform complex data into actionable insights—helping you identify inefficiencies, optimize workflows, and maximize profitability.'

//     }, 
//     {
//         name: 'Milking parlor services',
//         qrcode: require("../../assets/images/sh7.png"), 
//         description:'Comprehensive milking parlor hardware evaluation Milking process and efficiency optimization Performance management systems for operators and teams'

//     }, 
//     {
//         name: 'Hoof health management',
//         qrcode: require("../../assets/images/sh8.png"),
//         description:'Through intelligent data monitoring, workflow management, and precision hoof bath control, we significantly reduce hoof disease incidence. We also support facility design and implementation of effective hoof care programs.'

//     }, 
//     {
//         name: 'Heat stress control solutions',
//         qrcode: require("../../assets/images/sh9.png"),
//         description:'High-performance spraying systems Anti-drip, maintenance-friendly design 360° full-coverage cooling High-flow capacity to fully wet cows within 10 seconds'

//     }, 
//     {
//         name: 'Smart farm management services',
//         qrcode: require("../../assets/images/sh10.png"),
//         description:'The CIA can dispatch technical team to be stationed on-site at the enterprise, develop customized management plans, and train staff to master equipment operation and farming skills.'

//     }
// ])
// const farmListZh = ref([
//     {
//         name: 'PT-VI测试仪',
//         qrcode: require("../../assets/images/sh2.png"),
//         description:'真空系统ISO6690测试 脉动曲线测试 奶杯组NMC标准测试 湿法测试'
//     },
//     {
//         name: 'Vadia真空诊断仪',
//         qrcode: require("../../assets/images/sh3.png"),
//         description:'MTT:动态的挤奶过程测试 PT:依据ISO6690标准的脉动测试 FT：依据ISO6690标准的掉杯和套杯测试'

//     },
//     {
//         name: '应急服务',
//         qrcode: require("../../assets/images/sh4.png"),
//         description:'牧场出现问题第一时间电话或者远程解决，如果电话或远程无法解决的，工程师会在6小时内赶到现场解决。'


//     },
//     {
//         name: '驻场服务',
//         qrcode: require("../../assets/images/sh5.png"),
//         description:'专业的设备工程师长期驻守再牧场，提供一对一，7*24的服务。针对客户的设备制定专属维保方案，及时、有效应对、解决设备出现的问题'

//     }, 
//     {
//         name: '阿菲金专项服务',
//         qrcode: require("../../assets/images/sh6.png"),
//         description:'依据阿菲金精准的数据，逐渐形成自己的分析模板和数据分析平台，可对牧场各环节、各模块进行分析，给出合理化建议，帮助牧场发现问题，带来效益'

//     }, 
//     {
//         name: '挤奶厅专项服务',
//         qrcode: require("../../assets/images/sh7.png"), 
//         description:'奶厅硬件评估与测试 挤奶流程和挤奶效率专项评估及整体优化方案 细化到每个挤奶工及每个组别的挤奶厅绩效考核体系建立及优化方案'

//     }, 
//     {
//         name: '蹄病专项服务',
//         qrcode: require("../../assets/images/sh8.png"),
//         description:'借助阿菲金软件，通过软件揭发、软件工单、分群门精准蹄浴，全方位降低肢蹄病的发病率\n帮助牧场设计蹄浴池、知道牧场修蹄和蹄病防控方案落地'

//     }, 
//     {
//         name: '热应激专项服务',
//         qrcode: require("../../assets/images/sh9.png"),
//         description:'提供热应激全程解决方案 提供以色列专业喷头 防滴漏 360度无死角 排水量大，10秒就能喷湿牛的全身'

//     }, 
//     {
//         name: '智慧牧场托管服务',
//         qrcode: require("../../assets/images/sh10.png"),
//         description:'中联智农为企业需派驻技术团队驻场，制定个性化管理方案，并培训牧场员工掌握设备应用及养殖技能。'

//     }
// ])
const farmList = computed(() =>[
   {
        name:  t('farmList.farmname.name1'),
        description:t('farmList.farmDetails.details1'),
        qrcode: require("../../assets/images/sh2.png"),
    },
    {
        name:  t('farmList.farmname.name2'),
        description:t('farmList.farmDetails.details2'),
        qrcode: require("../../assets/images/sh3.png"),
    },
    {
        name:  t('farmList.farmname.name3'),
        description:t('farmList.farmDetails.details3'),
        qrcode: require("../../assets/images/sh4.png"),
    },
    {
        name:  t('farmList.farmname.name4'),
        description:t('farmList.farmDetails.details4'),
        qrcode: require("../../assets/images/sh5.png"),
    }, 
    {
        name:  t('farmList.farmname.name5'),
        description:t('farmList.farmDetails.details5'),
        qrcode: require("../../assets/images/sh6.png"),
    }, 
    {
        name:  t('farmList.farmname.name6'),
        description:t('farmList.farmDetails.details6'), 
        qrcode: require("../../assets/images/sh7.png"), 
    }, 
    {
        name:  t('farmList.farmname.name7'),
        description:t('farmList.farmDetails.details7'),
        qrcode: require("../../assets/images/sh8.png"),

    }, 
    {
        name:  t('farmList.farmname.name8'),
        description:t('farmList.farmDetails.details8'),
        qrcode: require("../../assets/images/sh9.png"),
       
    }, 
    {
        name:  t('farmList.farmname.name9'),
        description:t('farmList.farmDetails.details9'),
        qrcode: require("../../assets/images/sh10.png"),
    }
])
watch(locale, (newValue) => {
  if (newValue === 'en') {
    // farmList.value = farmListCn.value
    console.log('当前语言为英文c')
  } else if (newValue === 'zh') {
    console.log('当前语言为中文c')
    // farmList.value  = farmListZh.value
  }
}, { immediate: true })
</script>
<style lang="scss" scoped>
.about-box {
    margin: 0 auto;
    width: 1280px;
}

.about-banner {
    width: 100%;
    position: relative;

    img {
        display: block;
        width: 100%;
    }

    p {
        width:600px;
        position: absolute;
        text-align: center;
        left: 50%;
        margin-left: -300px;
        color: #fff;
    }

    .title {
        top: 160px;
        font-size: 40px;
        font-weight:600;
    }
    .subtitle {
      top: 240px;
      font-size: 18px;
      line-height:36px;
    }
    .learn-btn {
        cursor: pointer;
        top: 320px;
        width: 170px;
        height: 46px;
        font-size: 20px;
        line-height: 40px;
        position: absolute;
        text-align: center;
        left: 50%;
        border: 1px solid #fff;
        margin-left: -85px;
        color: #fff;
        border-radius: vars.$radius-4;

        &:hover {
            background-color: vars.$base-color;
            color: #fff;
            border: 1px solid vars.$base-color;
        }

        .topright-btn {
            margin-top: 10px;
        }
    }
}

.traninglist {
    width: 1280px;
    margin: 0 auto;
    padding-bottom: 60px;

    .title {
        padding: 60px 0px 40px 0px;
        font-size: 32px;
        text-align: center;
    }

    ul {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        li {
            overflow: hidden;
            flex: 1;
            margin-bottom:10px;
            padding: 12px;
            text-align: center;
            box-sizing:border-box;
            border: 2px solid #d9d9d9;
            img {
                margin: 0 auto;
                display: block;
                width: 100%
              
            }
            .span-txt {
                margin: 0 auto;
                display: block;
                height: 60px;
                line-height: 60px;
                text-align: center;
                width: 100%;
                font-size: 24px;
                background: #258E5C;
                color: #fff
            }

            .description {
                margin: 0 auto;
                display: block;
                height: 200px;
                box-sizing:border-box;
                line-height: 32px;
                text-align: left;
                width: 100%;
                padding:30px;
                background: #dee4e1;
                color: #000
            }
        }

    }
}
</style>